import { defineAttrs as e } from "../../utils/typed-attrs.js";
const t = e({
  type: { default: "messengerCard" },
  // TODO: use generics to type the canvas attribute
  canvas: { default: void 0 },
  text: { default: "" },
  messenger_app_id: { default: "" },
  uri: { default: "" }
}), s = {
  content: "",
  group: "block",
  marks: "",
  atom: !0,
  attrs: t,
  toDOM() {
    return ["div"];
  }
};
export {
  s as messengerCardSpec
};
